var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.valueToShow),function(v,index){return [_c('b-badge',{key:index,staticClass:"mr-1",attrs:{"pill":""}},[_vm._v(" "+_vm._s(v)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }